import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { LocationList } from '../../../../entities/v1/LocationList';
import { Location } from '../../../../entities/v1/applicant_tracking/Location';

export interface ListParams {
  name?: string;
  page?: number;
  pageSize?: number;
  expand?: string[];
}

interface LocationParams {
  name: string;
  country: string;
  address: string;
  city?: string;
  state?: string;
}

export class LocationService {
  public static list(params: ListParams) {
    return ApiService.get<LocationList>(
      '/api/v1/applicant_tracking/locations',
      snakecaseKeys(params),
    );
  }

  public static create(params: LocationParams) {
    return ApiService.post<Location>(
      '/api/v1/applicant_tracking/locations',
      snakecaseKeys(params),
    );
  }
}
